import Input from "../../../components/Input";
import Select from "react-select";
import { useCorporateListWithAgencies } from "../../../hooks/useCorporateListWithAgencies";
import { useTranslation } from "../../../hooks/useTranslation";
import { useLocales } from "../../../hooks/useLanguages";
const UpdateUser = ({
    userEditData,
    handleEditChanges,
    user,
    userRolesData,
    agencyData,
    chosenRoles,
    setChosenRoles,
    chosenAgency,
    setChosenAgency,
    setEditModal,
    userInfo,
    handleCreateUser,
    chosenLocales,
    setChosenLocales,
}) => {
    const { data: corporateListWithAgencies, isLoading: isLoadingCorporateListWithAgencies } = useCorporateListWithAgencies();
    const { data: localesData } = useLocales({enabled: userInfo?.is_global});
    const {t} = useTranslation();

    const localesOptions = localesData?.map(locale => ({
        value: locale.id,
        label: <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
            <img width={20} height={20} src={locale.url} alt={locale.name} />
            {locale.name}
        </div>,
    }));

    const handleLocaleChange = (selectedLocales) => {
        setChosenLocales(selectedLocales);
    };
    return (
      <form className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('managementRow.modals.updateUser')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setEditModal(false)}
            />
          </div>
          <div className='modal__content-body user'>
            <Input
              id='first_name'
              name='first_name'
              placeholder={t('managementRow.labels.firstName')}
              label={t('managementRow.labels.firstName')}
              type={'text'}
              defaultValue={userEditData?.first_name}
              onChange={handleEditChanges}
              required={true}
              disabled={user?.is_sso_auth}
            />
            <Input
              id='last_name'
              name='last_name'
              placeholder={t('managementRow.labels.lastName')}
              label={t('managementRow.labels.lastName')}
              type={'text'}
              defaultValue={userEditData?.last_name}
              onChange={handleEditChanges}
              required={true}
              disabled={user?.is_sso_auth}
            />
            <Input
              id='ein'
              name='ein'
              placeholder={t('managementRow.labels.ein')}
              label={t('managementRow.labels.ein')}
              type={'text'}
              defaultValue={userEditData?.ein}
              onChange={handleEditChanges}
              required={true}
              disabled={user?.is_sso_auth}
            />
            <Input
              id='email'
              name='email'
              placeholder={t('managementRow.labels.email')}
              label={t('managementRow.labels.email')}
              type={'email'}
              required={true}
              defaultValue={userEditData?.email}
              onChange={handleEditChanges}
              disabled={user?.is_sso_auth}
            />
            <Input
              required={true}
              defaultValue={userEditData?.initials}
              onChange={handleEditChanges}
              id='initials'
              name='initials'
              placeholder={t('managementRow.labels.initials')}
              label={t('managementRow.labels.initials')}
              type={'text'}
              disabled={user?.is_sso_auth}
            />
            {user?.role_title?.toLowerCase() === 'corporate' ? (
              <label className='checkbox-container'>
                {t('managementRow.labels.apiAccessOnly')}
                <input
                  key={userEditData?.api_access_only}
                  type={'checkbox'}
                  id={'api_access_only'}
                  name={'api_access_only'}
                  onChange={handleEditChanges}
                  defaultChecked={userEditData?.api_access_only}
                  disabled={user?.is_sso_auth}
                />
                <span className='checkmark'></span>
              </label>
            ) : null}
            {!userInfo?.is_corporate ? (
              user?.role_title?.toLowerCase() === 'global admin' ? null : (
                <>
                  {userInfo?.is_global &&
                  (user?.role_title === 'Corporate' ||
                    user?.role_title === 'Regional corporate') ? (
                    <></>
                  ) : (
                    <div className='customSelect'>
                      <span className='customSelect__label'>{t('managementRow.labels.userRoles')}</span>
                      <Select
                        isDisabled={
                          user?.is_sso_auth ||
                          (userEditData?.is_sso_auth &&
                            !userEditData?.ignore_sso_role)
                        }
                        options={userRolesData
                          ?.filter(
                            el =>
                              el.key !== 'corporate' &&
                              el.key !== 'global' &&
                              el.key !== 'regional_corporate',
                          )
                          ?.map(role => ({
                            value: role.id,
                            label: role.name,
                          }))}
                        value={chosenRoles}
                        onChange={e => {
                          setChosenRoles(e);
                          setChosenLocales([]);
                          setChosenAgency({});
                        }}
                          styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                        borderRadius: 8,
                        height: 42,
                        backgroundColor: '#F4F5F6',
                        marginTop: 8,
                      }),
                      group: (baseStyles) => ({
                        ...baseStyles,
                        marginTop: -10,
                      }),
                      groupHeading: (baseStyles) => ({
                        ...baseStyles,
                        color: '#6B7280',
                        fontWeight: 600,
                        fontSize: '14px',
                        padding: '8px 12px',
                        backgroundColor: '#F9FAFB',
                        borderBottom: '1px solid #E5E7EB',
                        cursor: 'default',
                        margin: 0,
                      }),
                      option: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#F3F4F6' : 'transparent',
                        color: state.isSelected ? 'white' : '#374151',
                        cursor: 'pointer',
                        padding: '8px 12px 8px 25px',
                        borderLeft: '2px solid transparent',
                        '&:hover': {
                          backgroundColor: state.isSelected ? '#3B82F6' : '#F3F4F6',
                          borderLeftColor: '#3B82F6',
                        },
                        '&:focus': {
                          borderLeftColor: '#3B82F6',
                        },
                      }),
                      menuPortal: (baseStyles) => ({
                        ...baseStyles,
                        zIndex: 9999,
                        marginTop: -7,
                      }),
                    }}
                    menuPortalTarget={document.body}
                      />
                    </div>
                  )}
                </>
              )
            ) : userInfo?.is_corporate &&
              user?.role_title?.toLowerCase() === 'corporate' ? null : (
              <div className='customSelect'>
                <span className='customSelect__label'>{t('managementRow.labels.userRoles')}</span>
                <Select
                  isDisabled={user?.is_sso_auth || !userInfo?.is_global}
                  options={userRolesData
                    ?.filter(
                      el =>
                        el.key !== 'corporate' &&
                        el.key !== 'global' &&
                        el.key !== 'regional_corporate',
                    )
                    ?.map(role => ({
                      value: role.id,
                      label: role.name,
                    }))}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                      borderRadius: 8,
                      height: 42,
                      backgroundColor: '#F4F5F6',
                      marginTop: 8,
                      textTransform: 'capitalize',
                    }),
                  }}
                  value={chosenRoles}
                  onChange={e => {
                    setChosenLocales([]);
                    setChosenAgency({});
                    setChosenRoles(e);
                  }}
                  menuPosition={'absolute'}
                />
              </div>
            )}

            {chosenRoles?.value === 10 && (
              <div className='customSelect'>
                <span className='customSelect__label'>{t('userManagement.inviteModal.locale')}</span>
                <Select
                  options={localesOptions}
                  isMulti
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                      borderRadius: 8,
                      minHeight: 42,
                      backgroundColor: '#F4F5F6',
                      marginTop: 8,
                    }),
                  }}
                  name={'locale'}
                  onChange={handleLocaleChange}
                  value={chosenLocales}
                  menuPosition='fixed'
                  placeholder={t('userManagement.inviteModal.localePlaceholder')}
                />
              </div>
            )}

            {agencyData &&
              chosenRoles?.value !== 10 &&
              chosenRoles?.value !== 1 && !userInfo?.is_corporate &&
              user?.role_code?.toLowerCase() !== 'corporate' &&
              user?.role_code?.toLowerCase() !== 'regional corporate' && !isLoadingCorporateListWithAgencies && (
                <div className='customSelect'>
                  <span className='customSelect__label'>{t('managementRow.labels.fbo')}</span>
                  <Select
                    isDisabled={user?.is_sso_auth || user?.role_title?.toLowerCase() === 'global admin'}
                    options={corporateListWithAgencies || []}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                        borderRadius: 8,
                        height: 42,
                        backgroundColor: '#F4F5F6',
                        marginTop: 8,
                      }),
                      group: (baseStyles) => ({
                        ...baseStyles,
                        marginTop: -10,
                      }),
                      groupHeading: (baseStyles) => ({
                        ...baseStyles,
                        color: '#6B7280',
                        fontWeight: 600,
                        fontSize: '14px',
                        padding: '8px 12px',
                        backgroundColor: '#F9FAFB',
                        borderBottom: '1px solid #E5E7EB',
                        cursor: 'default',
                        margin: 0,
                      }),
                      option: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#F3F4F6' : 'transparent',
                        color: state.isSelected ? 'white' : '#374151',
                        cursor: 'pointer',
                        padding: '8px 12px 8px 25px',
                        borderLeft: '2px solid transparent',
                        '&:hover': {
                          backgroundColor: state.isSelected ? '#3B82F6' : '#F3F4F6',
                          borderLeftColor: '#3B82F6',
                        },
                        '&:focus': {
                          borderLeftColor: '#3B82F6',
                        },
                      }),
                      menuPortal: (baseStyles) => ({
                        ...baseStyles,
                        zIndex: 9999,
                        marginTop: -7,
                      }),
                    }}
                    menuPortalTarget={document.body}
                    name={'agency_ids'}
                    value={chosenAgency}
                    onChange={e => setChosenAgency(e)}
                    isSearchable={true}
                    placeholder={t('managementRow.labels.selectAgency')}
                  />
                </div>
              )}
            {user?.is_admin && (
              <div style={{marginTop: 20}} className='edit__user'>
                <label className='checkbox-container'>
                  {t('managementRow.labels.notifyCorrectiveActions')}
                  <input
                    disabled={user?.is_sso_auth}
                    type={'checkbox'}
                    id={'notify_corrective_actions'}
                    name={'notify_corrective_actions'}
                    onChange={handleEditChanges}
                    defaultChecked={userEditData?.notify_corrective_actions}
                  />
                  <span className='checkmark'></span>
                </label>
                <label className='checkbox-container'>
                  {t('managementRow.labels.notifyEquipment')}
                  <input
                    disabled={user?.is_sso_auth}
                    type={'checkbox'}
                    id={'notify_equipment'}
                    name={'notify_equipment'}
                    onChange={handleEditChanges}
                    defaultChecked={userEditData?.notify_equipment}
                  />
                  <span className='checkmark'></span>
                </label>
                <label className='checkbox-container'>
                  {t('managementRow.labels.notifyInspections')}
                  <input
                    disabled={user?.is_sso_auth}
                    type={'checkbox'}
                    id={'notify_inspections'}
                    name={'notify_inspections'}
                    onChange={handleEditChanges}
                    defaultChecked={userEditData?.notify_inspections}
                  />
                  <span className='checkmark'></span>
                </label>
                <label className='checkbox-container'>
                  {t('managementRow.labels.notifyObservation')}
                  <input
                    disabled={user?.is_sso_auth}
                    type={'checkbox'}
                    id={'notify_service_requests'}
                    name={'notify_service_requests'}
                    onChange={handleEditChanges}
                    defaultChecked={userEditData?.notify_service_requests}
                  />
                  <span className='checkmark'></span>
                </label>
              </div>
            )}
          </div>

          <div className='modal__content-bottom'>
            <button className='close' onClick={() => setEditModal(false)}>
              {t('managementRow.modals.close')}
            </button>
            <button className='save' onClick={handleCreateUser}>
              {t('managementRow.modals.save')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </form>
    );
};
  
export default UpdateUser;